export default __webpack_public_path__ + "static/media/Logo.488e8573.svg";